const getDevDomain = () => {
  if (document.location.hostname === 'localhost') {
    console.log('Using localhost domain', import.meta.env.FOOJI_DOMAIN);
    return import.meta.env.FOOJI_DOMAIN as string;
  }
  
  if (document.location.hostname.endsWith('fooji.dev')) {
    const splitHost = document.location.hostname.split('.')
    return splitHost.slice(Math.max(splitHost.length - 3, 0)).join('.');
  }
  
  if (document.location.hostname.endsWith('staging.fooji.qa')) {
    return 'staging.fooji.qa';
  }
}

const devDomain = getDevDomain();

if (devDomain) {
  window.FoojiDevConfig = {
    FOOJI_DOMAIN: devDomain,
    FOOJI_MICROSITE_DOMAIN: import.meta.env.FOOJI_MICROSITE_DOMAIN,
  };
}
